export default __webpack_public_path__ + "f359bfff9700d66de4ddc714ae2bcdf9.glb";